module.exports = {
  qqgdscpjypt: "全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）",
  qqgdscpjypt1: "全球高端水产品交易平台",
  qqgdscpjypt2: "（深圳国际金枪鱼交易有限公司）",
  zczh: "注册账号",
  yzmdl: "验证码登录",
  zhmmdl: "账号密码登录",
  sjh: "手机号",
  yzm: "验证码",
  yhylsjh: "银行预留手机号",
  qsrsjh: "请输入手机号",
  qsryzm: "请输入验证码",
  hqyzm: "获取验证码",
  qsrmm: "请输入密码",
  dl: "登录",
  dlsb: "登录失败",
  dlgqqcxdl: "登陆过期,请重新登陆...",
  zc: "注册",
  zcsb: "注册失败",
  yzmbnwk: "验证码不能为空",
  hqyzmsb: "获取验证码失败",
  yzmfscg: "验证码发送成功",
  sjhbnwk: "手机号不能为空",
  sjhgscw: "手机号格式错误",
  mmbnwk: "密码不能为空",
  mmtips: "密码必须是8-16位的英文字母、数字、字符，组合（不能是纯数字）",
  bottomcopyright1:
    "2023深圳国际金枪鱼交易有限公司 ICP备：粤ICP备2023112184号-1",
  bottomcopyright2: "京公网安备 11010802026156号",
  ztsc: "主题市场",
  hello: "您好",
  qrz: "去认证",
  rzhjkckjyxqy: "认证后即可查看交易详情页",
  qkh: "去开户",
  khhjkzptwcjy: "开户后即可在中心完成交易",
  khsbxycxkh: "开户失败，需要重新开户",
  qyz: "去验证",
  dzhyz: "待账户验证",
  rzqyykhqlxkf: "认证企业已经开户,请联系客服",
  zljyz: "资料校验中",
  shz: "审核中",
  clz: "处理中",
  dzqyz: "电子签约中",
  jnrzbzj: "缴纳入驻保证金",
  jnrzbzjhkschy: "缴纳入驻保证金后可上传货源",
  wyhyxzzycjj: "我有货源，想组织一场竞价",
  wyhyxzjmc: "我有货源，想直接卖出",
  yrz: "已认证",
  hyzx: "行业资讯",
  gd: "更多",
  qb: "全部",
  zq: "专区",
  kssj: "开市时间",
  ksz: "当前开市中",
  xsz: "当前休市中",
  xqyzxqldsj: "星期一至星期五（节假日除外）",
  morning: "上午:09:00-11:30",
  zwsj: "上午： 9:00-11:30 下午： 13:00-16:30",
  jjmc: "竞价卖出",
  jjmr: "竞价买入",
  wyddxzzycjj: "我有订单，想组织一场竞价",
  gpmc: "挂牌卖出",
  gpmr: "挂牌买入",
  wyddxsgyphy: "我有订单，想收购一批货源",
  bhtjy: "包含**条交易",
  bh: "包含 ",
  jyy: "条交易",

  jjkp: "即将开拍",
  jjks: "即将开始",
  bmz: "报名中",
  jxz: "进行中",
  yjs: "已结束",
  lp: "流拍",
  wbmd: "我报名的",
  zxsc: "最新上传",
  kpsj: "竞价时间",
  w: "我",
  wd: "我的",
  jg: "价格",
  qpj: "竞价销售底价",
  dqj: "当前价",
  cjj: "成交价",
  yuan: "元",
  zwxgxx: "暂无相关内容",

  ryd: "人阅读",
  qxdzcg: "取消点赞成功",

  bm: "报名",
  xzkhjl: "新增看货记录",
  jbxx: "基本信息",
  hymc: "货源名称",
  qsrhymc: "请输入货源名称",
  dw: "单位",
  djtxdw: "点击填写单位",
  tiao: "条",
  dun: "吨",
  zl: "重量",
  hydz: "货源地址",
  hyzp: "货源照片",
  scp: "上传照片",
  zdjz: "（最多9张）",
  bcqtxx: "其他补充信息",
  bcbtj: "保存并提交",
  cjfdxdydqjg: "出价幅度需大于当前价格",
  fscgddmfqr: "发送成功，等待卖方确认",
  cjcg: "出价成功",
  cjsb: "出价失败",

  sy: "首页",
  rz: "认证",
  grrz: "个人认证",
  gsrz: "公司认证",
  sczj: "上传证件",
  xm: "姓名",
  qsrxmxysfzbcyz: "请输入姓名,须与身份证保持一致",
  ztlx: "主体类型",
  djxzlx: "点击选择类型",
  jysx: "经营属性",
  djxzsx: "点击选择属性",
  jydz: "经营地址",
  djxzdz: "点击选择地址",
  xxdz: "详细地址",
  qsrxxdz: "请输入详细地址",
  jypx: "经营品项",

  djxzpx: "点击选择品项",
  gsmc: "公司名称",
  qsrgsmcxyyyzzyz: "请输入公司名称，须与营业执照名称一致",
  qsrgsmc: "请输入公司名称",
  lxr: "联系人",
  qsrlxr: "请输入联系人",
  qscsfz: "请上传身份证",
  qscsfzwssfxx: "请上传身份证完善身份信息",
  qpsbscndyyzz: "请拍摄并上传你的营业执照",
  djscsfzzm: "点击上传身份证人像面",
  djscsfzbm: "点击上传身份证国徽面",
  djscyyzz: "点击上传营业执照",
  tj: "提交",
  tjrz: "提交认证",
  thcg: "提交成功",
  tjsb: "提交失败",
  yqm: "邀请码",
  yqmxt: "邀请码（选填）",
  qtxyqm: "请填写邀请码",
  sryqmrwkbt: "输入邀请码，若无可不填",
  qd: "确定",
  qx: "取消",
  sctpyc: "上传图片异常",
  sfzxmysrxmbyzqcxtr: "身份证姓名与输入姓名不一致，请重新填写～",
  yyzzmcysrmcbtzqcxtx: "营业执照的名称与输入名称不一致，请重新填写～",
  tpsbycqcxsc: "图片识别异常,请检查上传图片信息",
  rzsb: "认证失败",
  rzyc: "认证异常",
  qsryqm: "请输入邀请码",

  grzx: "个人中心",
  zhye: "账户余额",
  wdye: "我的余额",
  ljczlc: "了解充值流程",
  tx: "提现",
  bccg: "保存成功",
  bcsb: "保存失败",
  bcyhcw: "保存用户错误",
  txtp: "头像图片",
  bdsjh: "绑定手机",
  hb: "换绑",
  dlmm: "登录密码",
  qsz: "去设置",
  xgmm: "修改密码",
  szmm: "设置密码",
  qr: "确认",
  djscndtx: "点击上传您的头像",
  hbsjh: "换绑手机号",
  qsrhbsjh: "请输入换绑手机号",
  dqsjh: "当前手机号",
  ghcg: "更换成功",
  xgcg: "修改成功",
  szcg: "设置成功",
  uploatips: "上传文件大小不能超过 5MB",
  success: "成功",
  fail: "失败",

  zhmx: "账户明细",
  mj: "卖家",
  maij: "买家",
  dj: "冻结",
  djmx: "冻结明细",
  yjcdj: "已解除冻结",
  zrtxje: "转入提现明细",
  pfmx: "赔付明细",

  rzbzj: "入驻保证金",
  bzjtips: "若卖方客户发起交易，入驻保证金须不低于10万元整。",
  bzjtips1: "试运营阶段，暂不实施此规定",
  zcdz: "转出",
  zrdz: "转入",

  qrcj: "确认出价",
  hpmc: "货品名称",
  zxjg: "最新价格",
  ykj: "一口价",
  jpcj: "竞价出价",
  cjf: "出价方",
  dunshu: "吨数",
  zdbmds: "最低报名吨数",
  grds: "购入吨数",
  cjje: "出价金额",
  qsrndgrds: "请输入您的购入吨数",
  qsrndcjje: "请输入您的出价金额",

  wddd: "我的订单",
  hyd: "货源地",
  shd: "收货地",
  djkckmfhy: "可点击查看卖方货源",
  hyzj: "货源总价",
  djtips: "定金（冻结履约保证金冲抵货款）",
  fwf: "服务费",
  wk: "尾款",
  ddbh: "订单编号",
  copy: "复制",
  cjsj: "创建时间",
  mffk: "买家付款",
  ccbg: "出厂报告",
  zskf: "专属客服",
  hckf: "华采客服",
  dfpkf: "待分配品控",
  lxpk: "联系品控",
  qfk: "去付款",

  txmfhy: "填写卖方货源",
  ckmfhy: "查看卖方货源",
  hyxx: "货源信息",
  ddxx: "订单信息",
  ksrbcne: "可输入补充内容..",
  bt: "必填",
  xt: "选填",
  fsgmf: "发送给买家",

  sztx: "设置提醒",
  sztxcg: "设置提醒成功",
  qxtxcg: "取消提醒成功",
  szsb: "设置失败",
  qxbmcg: "取消报名成功",
  ysz: "已设置",
  jjs: "距离结束",
  jks: "距离开始",
  sc: "时长",
  kdjckkhjl: "可点击查看看货记录",
  bm10sr: "报名**人",
  wg10ren: "围观**次",
  jybh: "交易编号",
  jplx: "竞价类型",
  jjfd: "加价幅度",
  jjfdjj: "降价幅度",
  jpsj: "竞价时间",
  jpsc: "竞价时长",
  fz: "分钟",
  yszq: "延时周期",
  jylx: "交易类型",
  scsj: "上传时间",
  lxdh: "联系电话",
  ppxq: "拍品详情",
  pkbb: "品控报告",
  cjjl: "出价记录",
  xqms: "需求描述",
  hyms: "货源描述",
  jjr: "竞价人",
  sj: "时间",
  ckgd: "查看更多",
  zwcjjl: "暂无出价记录",
  smewmdsj: "扫描二维码到手机",
  dqrp: "当前热拍",
  yhwrzqdgezxrz: "用户未认证，请前往个人中心进行认证",

  ckkhxx: "查看看货信息",
  lsjl: "历史记录",
  bmcg: "报名成功",
  dmfqr: "待买家确认",
  mfjj: "买家拒绝",
  mfcswcl: "买家超时未处理",
  bj: "编辑",
  delete: "删除",
  qrxgfsgmf: "确认修改发送给买家",
  qrscgkhxx: "确认删除该看货信息？",
  sccg: "删除成功",
  ldfs: "冷冻方式",
  jjsz: "竞价设置",
  jjrq: "竞价日期",
  djxzjjrq: "点击选择竞价日期",
  jjsj: "竞价时间",
  djxzjjsj: "点击选择竞价时间",
  jjsc: "竞价时长",
  djxxjjsc: "点击选择竞价时长",
  srsz: "输入数字",
  gpsz: "挂牌设置",
  jgsz: "交割设置",
  yf: "运费",
  djlybzj: "冻结履约保证金",
  tjhddsh: "提交后等待审核",

  bmlb: "报名列表",
  dqr: "待确认",
  yjj: "已拒绝",
  yqr: "已确认",
  bmbh: "报名编号",
  bmsj: "报名时间",
  sfjjbm: "是否拒绝报名?",

  syrzbzjy: "入驻保证金（元）",
  rzbzjtips1: "若卖家客户发起交易，入驻保证金须不低于10万元整",
  zrje: "转入金额",
  qsrzrje: "输入转入金额",
  qbzr: "全部转入",
  yczr: "由此转入",
  zrcg: "转入成功",
  zrsb: "转入失败",

  zcje: "转出金额",
  qsrzcje: "输入转出金额",
  qbzc: "全部转出",
  zcz: "转出至",
  zccg1: "转出成功",
  zcsb1: "转出失败",

  ktzfzh: "开通支付账号",
  grkh: "个人开户",
  qykh: "企业开户",
  gtgshkh: "个体工商户开户",
  khsb: "开户失败",
  wdyhk: "我的银行卡",
  yjhb: "一键换绑",
  bdyhk: "绑定银行卡",
  zhlx: "账户类型",
  qdjxz: "请点击选择",
  dgzh: "对公",
  dszh: "对私",
  ckr: "持卡人",
  qsrckrxm: "请输入持卡人姓名",
  qsrxm: "请输入姓名",
  yhkh: "银行卡号",
  qsrkh: "请输入卡号",
  khh: "开户行",
  qsrkhh: "请输入开户行",
  zcyh: "支持银行",

  wfbd: "我发布的",
  wdjy: "我的交易",
  wgzd: "我关注的",
  qtgn: "其他功能",

  yx: "邮箱",
  dz: "地址",
  kfzsewm: "客服专属二维码",
  qtxzgcyhdwzs: "请填写中关村银行向该对公账户打款金额",
  skjey: "收款金额（元）",
  ytjqnxddsh: "已提交，请耐心等待审核！",

  yey: "余额（元）",
  txje: "提现金额",
  qsrtxje: "输入提现金额",
  qbtx: "全部提现",
  dzyhk: "到账银行卡",

  jjcj: "竞价出价",
  ydzdcj: "已到最低出价",
  zklyx: "再考虑一下",
  jjcg: "竞价成功",
  jyts: "交易提示",
  qrybdyhk: "确认已绑定银行卡",
  syysyhkxrxzhhk: "使用以上银行卡向如下账户汇款",
  zhm: "账户名",
  zhzh: "账号",
  zhc: "张华采",
  bjyhzgczh: "北京中关村银行股份有限公司",
  xzf: "需支付",
  wkyf: "尾款应付",
  xzzffs: "选择支付方式",
  wdzh: "我的账户",
  qrzf: "确认支付",
  zhyebzljzr: "账户余额不足，了解转入",
  zfcg: "支付成功",
  bmxz: "报名须知",
  dqbdlybzj: "当前交易的履约保证金",
  ndzhye: "您的账户余额",
  bmjjjbstyxydjbzj: "报名竞价即表示同意支付缴纳竞价定金；",
  rwhpjth: "若未获拍，缴纳的定金会自动退还打款的账户；",
  rcgzcdhk: "若成功获拍，缴纳的定金会在您交付尾款时作为定金冲抵货款；",
  rcgpxjkc: "若您成功拍下后未履约，缴纳的定金将被扣除。",
  zhyebzwfbm: "账户余额不足，无法报名",
  qzr: "去转入",
  qrbm: "确认报名",

  zd: "转到",
  ye: "页",

  scxgzj: "上传相关证件",
  qscyyzz: "请上传营业执照",
  yyqx: "营业期限",
  qsryyqx: "请输入营业期限",
  zcdz1: "注册地址",
  qsrzcdz: "请输入注册地址",
  tyshxydm: "统一社会信用代码",
  qsrtyshxydm: "请输入统一社会信用代码",
  qsczzjgdmz: "请上传组织机构代码证",
  djsczzjgdmz: "点击上传组织机构代码证",
  zzjgdm: "组织机构代码",
  qsrzzjgdm: "请输入组织机构代码",
  zzjgdmzqx: "组织机构代码证期限",
  qsrzzjgdmzqx: "请输入组织机构代码证期限",
  qscswdjz: "请上传税务登记证",
  djscswdjz: "点击上传税务登记证",
  swdjzdm: "税务登记证代码",
  qscfrsfz: "请上传法人身份证",
  sfzh: "身份证号",
  qsrsfzh: "请输入身份证号",
  sfzyxq: "身份证有效期",
  qsryxq: "请输入有效期",
  qsclxrsfz: "请上传联系人身份证",
  lxrxm: "联系人姓名",
  lxrsfzh: "联系人身份证号",
  lxrsjh: "联系人手机号",
  qsrlxrsjh: "请输入联系人手机号",
  lxryx: "联系人邮箱",
  qsrlxryx: "请输入联系人邮箱",
  zhmc: "账户名称",
  qsrzhmc: "请输入账户名称",

  wdfb: "我的发布",
  tcdl: "退出登录",
  smjrxcx: "扫描进入小程序",
  czgjfbkj: "操作更加方便快捷",
  ss: "搜索",
  tgsh: "通过审核",
  js: "结束",
  bohui: "驳回",
  scdd: "生成",
  xgjg: "改价",
  qdgj: "确定改价",
  xjhyyy: "下架",
  bmhy: "报名货源",
  ckdd: "查看订单",
  pkdh: "品控电话",
  bmdjj: "报名的竞价",
  bmdgp: "报名的挂牌",
  dzdwz: "点赞的文章",
  mairu: "买入",
  maichu: "卖出",
  grxx: "个人信息",
  grsy: "个人首页",
  quhao: "区号",
  dfk: "待付款",
  djg: "待交割",
  ywc: "已完成",
  qt: "其他",
  dsh: "待审核",
  zsz: "展示中",
  nhqdl: "您好请登录",
  mfzc: "免费注册",

  jyzx: "交易平台",
  hyzx11: "行业资讯",
  qgsj: "全国数据",
  qqsj: "全球数据",
  cczx: "服务中心",
  gzzx: "平台规则",
  lxwm: "联系我们",
  sjzx: "价格指数",
  grzxxx: "个人中心",

  szgjjqyjyzx: "深圳国际金枪鱼交易有限公司",
  qqgdscpjyzx: "全球高端水产品交易平台",
  djjrjyzx: "点击进入交易平台",
  gjst: "共建生态",
  hzgyy: "合作共赢",
  gongsijieshao: "公司介绍",
  pingtaijieshao: "中心介绍",
  dazaoqqzddyyjypt: "打造全球高端水产品在线交易平台",
  gsjstips111:
    "由中国农业发展集团下属中水集团远洋股份有限公司发起，华采科技（北京）有限公司提供技术和专业的支持。",
  lliaojiexiangq: "了解详情",
  guankanship: "观看视频",
  xianshangjiaxianxia: "“线上”+“线下”",
  gsjstips222:
    "公司致力于打造全球高端水产品在线交易平台，以“线上”+“线下”双引擎驱动，将异地高端水产品通过远程数字化交易与现场竞价交易实现联动。",
  sjzgrdbzsrjg: "升级中国人的蛋白质摄入结构",
  gsjstips333:
    "以大食物观以指导，以共建生态、合作共赢为理念，以科技为手段推动高端水产品的产业数字化进程，提升全球高端水产品的交易流通效率，升级中国人的蛋白质摄入结构，重构全球高端水产品数字化新生态。",
  gaoduanshuichanpzonghefuwupingtai: "高端水产品综合产业服务中心",
  gsjstips444:
    "经深圳市政府批准，由中国农业发展集团、深圳港集团共同发起，由北京华采提供技术支持。做为深圳国家远洋渔业基地的先导项目投入运营。中心于2023年5月12日正式上线，是以高端水产品现货交易为主，集水产品标准制定、新品种研发推广，市场信息服务、技术服务、金融服务、物流服务为一体的高端水产品综合产业服务中心。",
  pingtai1: "覆盖全球主要高端水产品交易中心城市",
  pingtai2:
    "中心以深圳为枢纽，链接大连、烟台、舟山、东京、高雄、曼谷等全球重要高端水产品集散地城市，设立交割仓，实现全球交割； 中心除金枪鱼以外，还涵盖银鳕鱼、三文鱼、帝王蟹、龙虾等高端水产品品种。",
  pingtai3: "交易国际化、标准化、信息化和数字化",
  pingtai4:
    "中心承担着推动全球高端水产品产业的创新升级，实现水产品交易国际化、标准化、信息化和数字化的重任；中心将利用强有力的市场化运营能力、资源整合能力及优惠的政策配套资源，逐步建成亚太地区国际高端水产品交易、结算和定价中心。",
  adv1: "我们的优势",
  adv2: "云端交易、全球交割、专享资源、深圳价格",
  adv3: "高端",
  adv4: "高效",
  adv5: "高品质",
  adv7: "高质量",
  adv6: "打造亚太地区高端水产交易中心、结算中心、定价中心",
  cloud1: "云端交易",
  cloud2: "全球交割",
  cloud3: "专享资源",
  cloud4: "深圳价格",
  cloud5: "全程溯源",
  cloud6: "AI质检",
  cloud7: "数据引擎",
  cloudIntro1: "云端交易，一键买全球、卖全球，交易无限触达",
  cloudIntro2: "全球交割，全球主要集散地城市当地交割，降低物流成本",
  cloudIntro3: "专享资源，远洋蓝鳍金枪鱼全部捕捞配额，指定销售渠道",
  cloudIntro4:
    "深圳价格发布全球高端水产品集散地城市实际交易价格，助力中国市场确立定价中心地位",
  cloudIntro5: "产品全程溯源，还原产品真实信息，一鱼一码，实现百分百食用安全",
  cloudIntro6:
    "AI图像识别强化品控能力，通过统一检测标准降低传统验鱼误差，提高多场景应用效率",
  cloudIntro7: "数据引擎，通过大数据挖掘，增强决策准确度",
  gsdzzzzz:
    "公司地址：深圳市宝安区新安街道海滨社区宝兴路6号海纳百川总部大厦B座15层",
  xcxxxx: "小程序",
  fwhhhh: "服务号",
  wzdhhh: "网站导航",
  pzzx: "交割中心",

  login1: "共创生态 合作共赢",
  login9: "以科技推动高端水产品数字化进程",
  login11: "立即登录",

  person1: "个人首页",
  person2: "个人信息",
  person7: "开户流程",

  qkk: "去看看",
  wfbdjy: "我发布的交易",
  rxtel: "热线",
  kfrxxx: "客服热线",
  gzsjjj: "工作时间",
  jqy: "金枪鱼",
  qtpl: "其他品类",
  cjjjj: "成交",
  qpppp: "起拍",
  plll: "品类",
  pxxx: "品项",

  jqyfl: "金枪鱼分类",
  zzjx: "正在进行",
  jssj: "结束时间",
  ysztx: "已设置提醒",
  dpsjgzg: "大屏数据更直观",
  cdxx: "产地信息",
  ggzbjdx: "规格占比及大小",
  hours: "时",
  minus: "分",
  second: "秒",
  wxsys: "微信扫一扫",

  service1: "我们有哪些服务",
  service2: "用我们的服务全面赋能实现业务增长",
  service3: "金融服务",
  service4:
    "旨在为上下游客户提供全方位的金融支持，帮助他们解决资金周转难题，提高交易效率，降低交易成本",
  service5: "全面",
  service6: "物流服务",
  service7:
    "旨在为上下游客户提供高效、便捷的物流支持，帮助他们更好地完成交易和物流配送",
  service8: "高效",
  service9: "数据服务",
  service10:
    "旨在为上下游客户提供全面、及时、准确的交易数据和市场信息，帮助他们了解市场动态和趋势，做出更明智的交易决策",
  service11: "专业",
  service12: "全面了解",
  service13:
    "包含融资服务、结算服务、风险管理服务等，旨在为上下游客户提供全方位的金融支持，帮助他们解决资金周转难题，提高交易效率，降低交易成本，中心还计划进一步拓展金融服务，包括建立金融产品创新中心等，为上下游客户提供更加全面、专业的金融服务。",
  service14:
    "包括仓储服务、配送服务、报关服务、保险服务等，旨在为上下游客户提供高效、便捷的物流支持，帮助他们更好地完成交易和物流配送。中心还计划进一步拓展物流服务，包括建立物流信息平台、开发物流管理SAAS工具等，为上下游客户提供更加全面、高效的物流支持。",
  service15:
    "包括实时行情数据、交易数据分析、市场信息发布、数据定制服务等，旨在为上下游客户提供全面、及时、准确的交易数据和市场信息，帮助他们了解市场动态和趋势，做出更明智的交易决策。中心还计划进一步拓展数据服务，包括建立数据中心、开发数据分析软件等，为上下游客户提供更加全面、专业的数据支持。",
  slx: "数量（箱）",
  cdmc: "产地名称",
  rknf: "捕捞年份",
  rkyf: "捕捞月份",
  ggzbjdxplace:
    "请写出货源包含的规格占比及大小情况，例如：规格100-150占比25%，偏大；规格200-3000占比75%，正常大小",
  rules1:
    "全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）规则汇总（试用）",
  rules2: "第一章 总则",
  rules3: "第一条",
  rules4:
    "为规范全球高端水产品交易平台（暨深圳国际金枪鱼交易有限公司）的线上交易规则（以下简称交易平台），维护市场秩序，保障交易商的合法权益，参考《中华人民共和国民法典》、《第三方电子商务交易中心服务规范》等相关法律法规等规定，制定本细则。",
  rules5: "第二条",
  rules6:
    "本规则适用于在全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）的交易活动。交易平台所有的工作人员、会员、做市商、交收仓库及相关合作机构必须遵守本规则。",
  rules7: "第二章 交易",
  rules8: "第三条 开市时间",
  rules9: "1.星期一至星期五（节假日除外）：每天9:00-11:30 13:00-16:30；",
  rules10: "2.星期六、星期日和法定节假日不开市。",
  rules11: "第四条 收费标准",
  rules12:
    "买卖双方根据不同的交易方式、品类需支付不同的费用，详细请参考《平台收费标准》",
  rules13: "角色",
  rules14: "买家",
  rules15: "卖家",
  rules16: "发起交易模式",
  rules17: "交易规则",
  rules18:
    "买家上传采购需求，设置竞价销售底价，卖家根据买家需求进行竞价，价低者得。",
  rules19: "买家上传采购需求，设定了价格与数量等门槛，卖家根据买家需求售卖。",
  rules20: "卖家上传售卖货物，设置竞价销售底价，买家根据卖家需求进行竞价。",
  rules201:
    "卖家上传售卖货源明细，设置竞价销售底价，买家根据卖家需求进行竞价。",
  rules21:
    "卖家上传货物明细，设定了价格与数量等门槛，买家根据卖家货物情况购买。",
  rules22: "中心收费标准",
  rules23: "（暂行）",
  rules24: "参与交易的买家收取货值的3‰作为服务费",
  rules25: "参与交易的卖家收取货值1‰的作为服务费，50万元封顶",
  rules26: "保证金",
  rules27:
    "发布交易或者参与竞价均需要缴纳货款的20%作为履约保证金，未中标或者中标完成交易后，履约保证金退回。",
  rules28: "入驻保证金10万元即可发布、参与交易",
  rules29: "付款及发货时间",
  rules30: "下单后24小时内缴纳尾款",
  rules31: "（如逾期需联系中心处理）",
  rules32: "买家付清全款后根据约定时间发货",
  rules33: "第五条",
  rules34: "报价币种为人民币，报价单位为：根据品类的要求具体设定。",
  rules35: "第六条",
  rules36:
    "所有用户须缴纳足额保证金后方可在本交易平台作为买卖家，正常参与发布卖出/买入或报名/出价。",
  rules37: "第七条 交易保证金",
  rules38:
    "买卖家需根据交易平台的要求缴纳相应的交易保证金，交易成功后，保证金将冲抵货款。",
  rules39: "第八条 保证金退还",
  rules40: "符合退还条件的，一般会在2个工作日原路径退回付款账户。",
  rules41: "第九条 保证金扣罚",
  rules42:
    "卖家发布的货源被成功竞价，涉及如下情形中任何一条，将被扣罚与成交额等值的保证金，若保证金不足则扣除已缴纳全额：",
  rules43: "1.交割货源质量与描述严重不符；",
  rules44: "2.未按照规定的时间和程序，完成货物交割办理；",
  rules45: "3.未按照竞价公示价格履行合约。",
  rules46: "4.中心将扣罚与成交额等值的保证金，若保证金不足则扣除已缴纳全额。",
  rules47:
    "如买家竞价成功后，涉及如下情形中任何一条，将被扣罚与成交额等值的保证金，若保证金不足则扣除已缴纳全额：",
  rules48: "1.未按照规定的时间和程序，完成货物交割办理；",
  rules49: "2.未按照竞价公示价格履行合约。",
  rules50: "3.中心将扣罚与成交额等值的保证金，若保证金不足则扣除已",
  rules51: "第十条 保证金罚没去向",
  rules52:
    "1.竞价成功，但买家未在竞价结束后的1个自然日（交易付款期内）及时完成付款，且该笔交易不支持协商恢复交易的，买家缴纳的保证金将在交易付款期结束后被罚没并赔付给卖家。",
  rules53:
    "2.竞价成功，但买家未在竞价结束后的2个自然日（交易付款期内）及时完成付款，且该笔订单在协商恢复交易期内未申请恢复交易，买家缴纳的保证金将在恢复交易期结束后被罚没并赔付给卖家。",
  rules54:
    "3.竞价成功，但买家未在竞价结束后的1个自然日（交易付款期内）及时完成付款，且该笔订单在协商恢复交易期内申请恢复但未被卖家处理或被拒绝恢复交易，买家缴纳的保证金在被拒绝恢复交易后被罚没并赔付给卖家。",
  rules55:
    "4.缴纳了保证金的卖家在成交后未依约向买家交付拍品的，卖家缴纳的保证金将被罚没并赔付给买家。",
  rules56: "第十一条 罚没保证金扣除服务费",
  rules57:
    "1.因买家违约或违规导致买家缴纳的保证金被罚没给卖家的，将不退还服务费，并有权在罚没保证金时直接扣除。",
  rules58:
    "2.因卖家违约或违规导致卖家缴纳的保证金被罚没给买家的，将针对实际情况扣除相应的入驻保证金。",
  rules59:
    "3.特殊情况：对于保证金的返还或扣罚您有任何异议，可通过平台申诉，平台作为中间方，公平协调买、卖家进行责任判定是否返还保证金或做相应扣罚处理。",
  rules60: "第十二条",
  rules61:
    "上传信息应当包含但不限于：类型、品类品项规格、吨数、捕捞时间、捕捞方式、冷冻方式、捕捞海域、售卖方式、货源方、货源照片、货源描述等。",
  rules62:
    "货源描述：名称、重量大小、等级、野生/养殖、货源形态（原条/切割）、规格、冷冻方式、包装情况、定重过磅扣点等其他补充信息。",
  rules621: "订单描述：品类、价格、发货地，发票信息等。",
  rules63: "第十三条 交易方式及选择建议",
  rules64: "1.用户可以选择自行登录平台竞价和挂牌。",
  rules65:
    "2.延时：竞价初始时长为2分钟，在结束前倒计时10秒之内，如有新的出价，则转入延时竞价（延时30秒），若在延时倒计时10秒内，仍有新的报价，则重启30分钟倒计时，以此类推，最多延时次数60次，直到在倒计时结束前无人继续出价，竞价结束。 ",
  rules66: "注意事项",
  rules67: "注意要设置采购数量门槛，防止恶意竞价。例：一吨货物低价竞争。",
  rules68: "了解市场价格趋势，确保交易顺利进行。",
  rules69: "货源详情记录清晰，确保交易质量。",
  rules70: "货源详情记录清晰，确保交易质量。",
  rules71: "选择建议",
  rules72: "货品价格有下降趋势，预算有限的情况下建议选择。",
  rules73: "对货品市场价格把控精准且长期购买货物的建议选择。",
  rules74:
    "货源优质且市场价格稳定或有上升趋势，货主不清楚货源价值，想更高价格售出的建议选择。",
  rules75: "价位有明确心理预期的建议选择。",
  rules76: "第三章 实物交收",
  rules77: "第十四条",
  rules78: "中心交易成功后，买卖家办理标的出库、权益变更及交割等事宜。",
  rules79: "第十五条",
  rules80:
    "履约约定：成交后，买卖双方客户有任何一方出现毁约行为（符合保证金扣罚的情形），除履行客诉流程、保证金扣罚外，该客户也将纳入交易平台客户黑名单，影响或限制参与后续交易。",
  rules81: "第四章 附则",
  rules82: "第十六条",
  rules83:
    "本规则的解释权和修定权属于全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）所有。",
  rules84: "第十七条",
  rules85:
    "全球高端水产品交易平台（深圳国际金枪鱼交易有限公司）有权根据交易平台需求对保证金规则进行修订和调整，修订后的规则将通过站内信、网站公示等合适的方式通知用户。如用户在保证金规则修订后继续使用本交易平台且缴纳了保证金的，则视为用户已经完全理解并接受修订后的保证金规则，同意本交易平台根据修订后的规则管理用户缴纳的保证金。",
  rules86: "第十八条",
  rules87:
    "因本规则产生的争议各方应友好协商解决，协商无法解决的，各方均同意将争议事项提交至相关仲裁部门，按申请仲裁时该院现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对各方均有约束力。",
  rules88: "第十九条",
  rules89:
    "本规则的解释和执行均适用中国大陆地区的法律，本规则的任何条款被认定为无效的不影响其他条款的效力。",
  rules90: "第二十条",
  rules91: "本规则自发布之日起执行。",
  contact1: "电话：400-101-2799",
  contact2: "邮箱：szittop@cofc.com.cn ",
  contact3:
    "地址：深圳市宝安区新安街道海滨社区宝兴路6号海纳百川总部大厦B座15层",
  contact4: "扫一扫",
  contact5: "查看小程序",
  contact6: "关注",
  contact7: "公众号",

  indexnew1: "打造全球高端水产品在线交易平台",
  indexnew2:
    "经深圳市政府批准，由中国农业发展集团、深圳港集团共同发起，由北京华采提供技术支持。做为深圳国家远洋渔业基地的先导项目投入运营。",
  indexnew3: "标准化评级定价系统",
  indexnew4: "专业品控团队",
  indexnew5: "AI技术",
  indexnew6: "溯源",
  indexnew7: "交割系统",
  indexnew8: "交割仓网络",
  indexnew9: "信用系统",

  delivery1: "全球高端水产品交易平台全球交割仓",
  delivery2: "为交易平台的高端水产品提供全球化的交割服务",
  delivery3:
    "全球交割仓包括交易平台自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了高端水产品主要产区和消费区的重要城市和港口。",
  delivery4: "国际化、规范化、专业化、品牌化",
  delivery5:
    "全球交割仓的建设和发展，为交易平台的高端水产品提供更加便利、高效、安全、可靠的交割服务，扩大交易平台的国际影响力和知名度。",
  delivery6: "加强与国内外合作伙伴的合作",
  delivery7:
    "目前，交易平台已经与万纬冷链建立战略合作伙伴关系。未来，交易平台将继续加强与国内外合作伙伴的合作，扩大全球交割仓的网络和覆盖范围，提高交割服务的质量和效率，为客户提供更加优质的服务和更加便利的交割方式。",
  delivery8: "覆盖主要沿海集散地城市",
  delivery9:
    "覆盖国内主要沿海集散地城市：大连、青岛、宁波、舟山、福州、深圳等；覆盖中国及东亚地区：东京、釜山、曼谷等；",
  delivery10:
    "全球高端水产品交易平台全球交割仓是指交易平台在全球范围内建立的交割仓库网络，旨在为交易平台的高端水产品提供全球化的交割服务。全球交割仓包括交易平台自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了高端水产品主要产区和消费区的重要城市和港口。",
  delivery11:
    "全球交割仓的建设和发展，是交易平台实现“国际化、规范化、专业化、品牌化”的发展战略的重要组成部分。全球交割仓的建设和发展，可以为交易平台的高端水产品提供更加便利、高效、安全、可靠的交割服务，扩大交易平台的国际影响力和知名度。",
  delivery12:
    "目前，交易平台已经与万纬冷链建立战略合作伙伴关系。未来，交易平台将继续加强与国内外合作伙伴的合作，扩大全球交割仓的网络和覆盖范围，提高交割服务的质量和效率，为客户提供更加优质的服务和更加便利的交割方式。",
  delivery13: "交割仓网络阶段建设发展规划：",
  delivery14:
    "第一阶段：覆盖国内主要沿海集散地城市：大连、青岛、宁波、舟山、福州、深圳等；",
  delivery15: "第二阶段：覆盖中国及东亚地区：东京、釜山、曼谷等；",
  delivery16: "第三阶段：覆盖一带一路国家主要集散地城市。",
  rksj: "捕捞时间",
  szjg: "深圳价格",
  nian: "年",
  yue: "月",
  zajzzz: "正在加载",
  flllll: "分类",
  newwwwww: "-------------20240902----------------------------------",
  ccfw: "仓储服务",
  pkfw: "品控服务",
  qgfw: "清关服务",
  hyqy: "会员企业",
  ztgzhzsy: "《整体规则汇总试用》",
  bzjxy: "《保证金协议》",
  grysjbhxy: "《个人信息保护及隐私政策》",
  xwzx: "新闻资讯",
  gjhczx: "国际海产资讯",
  gywm: "关于我们",
  title1: "一分钟找遍全球 一站式专业服务",
  title2:
    "深圳国际金枪鱼交易有限公司经深圳市政府批准于2023年9月1日正式成立，致力于打造深圳国际高端水产品交易平台，作为深圳国家远洋渔业基地的先导项目投入运营，将助力深圳市实施三年现代渔业发展规划，强化渔业转型，建设高端水产品交易、展示、仓储、物流、金融于一体的国际高端水产品交易平台。",
  kjmy: "跨境贸易",
  title3: "量身定制您的战略规划，小到每个细节",
  title4: "高效通关",
  title5: "可提供先货后税的服务助力国内客户快速通关",
  title6: "保证链条业务效率",
  title7: "无忧采购",
  title8: "引入金融机构助力国内买家提供采购融资服务",
  title9: "提高采购能力和助力扩大业务规模",
  title10: "流程风控",
  title11: "根据协议规定的流程作业",
  title12: "任何超出的流程都将被系统禁止操作",
  title13: "交易保障更放心",
  title14: "汇率保值",
  title15: "通过银行代客锁汇",
  title16: "控制汇率风险",
  title17: "做好采购成本管理",
  title18: "价格管理",
  title19: "通过大数据分析产品周期及市场情况",
  title20: "进行预判并自动调整垫资比例",
  title21: "全链条解决方案",
  title22: "让您全程无忧",
  title23: "订单洽谈",
  title24: "集中采购",
  title25: "单据文件",
  title26: "支付/融资结算",
  title27: "跨境物流",
  title28: "智慧通关",
  title29: "财税咨询服务",
  title30: "仓储代替",
  title31: "物流运输",
  title32: "加工服务",
  title33: "无忧采购，助力客户优化现金流",
  title34: "资金更灵活，采购更轻松，成本更确定",
  title35: "尾款垫付",
  title36:
    "可以为国内符合准入条件的下游客户垫付尾款，缓解备货压力，扩大业务规模，助力其抢占国内市场份额",
  title37: "灵活用款",
  title38: "随借随还，资金随货物的采销进行借还",
  title39: "外汇保值",
  title40: "引入金融机构为国内下游客户提供锁汇等服务，控制采购成本",
  title41: "快捷体验",
  title42: "线上服务，按订单用款和还款，业务清晰，国内下游客户接单更轻松",
  title43: "服务范围",
  title44:
    "每月汇总各口岸进口清关的情况报表，对已经出现的问题提出专业的清关意见。",
  title45: "及时发送国内检验检疫和海关对水产品进口的资讯并提供相关的解决方案。",
  title46: "我司目前与多家清关公司合作，对我司平台上的客户提供清关服务。",
  title47: "抗风险能力强",
  title48: "“以销定采”、“集中采购”的模式，抗风险 能力强",
  title49: "服务能力优异",
  title50: "系保障民生的政府重点扶持企业",
  title51: "系统化、流程化、信息化、智能化运营",
  title52: "IT系统铺设到位，人力成本及维护成本大幅降低，对同业形成竞争壁垒 ",
  title53: "清关流程",
  title54: "准确把握服务中的每一个细节，给您满意的体验",
  title55: "订单",
  title56: "运输",
  title57: "港口申报",
  title58: "检验检疫",
  title59: "查验放行",
  title60: "入库分销",
  title61: "平台价值定位",
  title62: "结算中心",
  title63: "物流中心",
  title64: "定价中心",
  title65: "标准中心",
  title66: "大数据中心",
  title67: "金融服务中心",
  title68: "七大优势",
  title69: "云端交易",
  title70: "一键买全球、卖全球，交易无限触达。",
  title71: "通过大数据挖掘，增强决策准确度。",
  title72: "全球主要集散地城市当地交割，",
  title73: "降低物流成本。",
  title74: "还原产品真实信息，“一鱼一码”，",
  title75: "实现百分百食用安全。",
  title76: "远洋蓝鳍金枪鱼全部捕捞配额，",
  title77: "指定销售渠道。",
  title78:
    "发布全球金枪鱼集散地城市实际交易价格，助力中国市场确立定价中心地位。",
  title79: "智能质检",
  title80:
    "AI图像识别强化品控能力，通过统一检测标准降低传统验鱼误差，提高多场景应用效率。",
  title81: "平台介绍",
  title82:
    "深圳国际金枪鱼交易有限公司是经深圳市渔业主管部门批准，由中国农业发展集团发起，为中水集团远洋股份有限公司控股的全资子公司。该公司运营的全球高端水产品交易平台是以金枪鱼为主的高端水产品交易服务平台，旨在为客户提供从存储到交易、物流、展示、消费于一体的交易服务，实现“云端交易、全球交割”，致力于打造高效优质的高端水产品线上交易服务平台。",
  title83:
    "平台将以深圳为中心，向外有效链接大连、青岛、宁波、舟山、福州等高端水产品集散地城市，并逐步增设交割仓，实现覆盖全球主要的高端水产品交易城市，积极助力深圳现代渔业形成具备国际竞争力、吸引力、影响力的现代渔业产业集群。",
  title84: "办公地·深圳市海纳百川大厦",
  title85: "平台未来发展战略",
  title86:
    "即以高端水产品交易为核心，建设以云端交易、全球交割为主的线上线下立体交易体系，逐步扩大交易品种和国内外交割覆盖范围；建设立足全国，面向东亚、南亚，服务“一带一路”国家和地区的高端水产品交易平台，将异地高端水产品通过远程数字化交易平台与现场竞价交易实现联动，构建全球高端水产品大流通的格局。",
  title87:
    "构建全球高端水产品关键节点的服务体系——结合各国地区政府政策，在高端水产品核心产区，围绕捕捞、养殖、转运、加油、仓储、金融、加工、品控评级等增值服务环节构建服务体系，控制产业链前端关键资源，打造稳定高品质供给基地。构建销地中心节点城市的渠道下沉服务体系——在北京、上海、广州、深圳、成都、重庆、武汉等直辖市、省会城市，通过合作模式建立干线物流、前置仓、城配等服务体系。",
  title88: "冷运仓储",
  title89: "提供货物冷库存储、分拣、包装、配送、信息流转等一体化冷运服务",
  title90: "多温区管控",
  title91: "多温区存储",
  title92: "全天24H温度监控，过程可溯",
  title93: "覆盖范围广",
  title94: "通过各仓辐射范围",
  title95: "干、配可覆盖中国内地大部分地区",
  title96: "多品类服务",
  title97: "整进零出",
  title98: "可提供小批次多品类操作服务",
  title99: "全国分仓",
  title100: "提供中国内地分仓服务",
  lang1: "品控服务是指对水产品进行品质控制和监督的服务。",
  lang2: "旨在确保水产品的品质符合相关标准和要求。",
  lang3:
    " 通过对产品质量的监控和控制，以确保水产品的新鲜度、外观等指标符合质量标准。",
  lang4: "服务内容",
  lang5: "原料检验",
  lang6:
    "对水产品原料进行检验，包括鱼类、虾类、贝类等，以确保原料的质量和安全性。",
  lang7: "过程监控",
  lang8:
    "监控水产品的生产过程，包括加工、冷冻、包装等环节，以确保每个环节符合质量标准和操作规程。",
  lang9: "质量抽检",
  lang10:
    "对冻品进行定期的质量抽检，包括外观、口感、营养成分等方面的检测，以确保产品的品质符合标准。",
  lang11: "标签和包装检查",
  lang12:
    "检查水产品的标签和包装，确保产品的标识和包装符合法规要求，提供正确的产品信息和保护产品的完整性。",
  lang13: "供应链管理",
  lang14:
    "对水产品的供应链进行管理和监控，包括供应商评估、物流管理等，以确保产品的来源和去向可追溯，并保证供应链的稳定性和可靠性。",
  lang15: "服务优势",
  lang16: "品控服务可以确保水产品的品质符合相关标准和要求",
  lang17: "减少产品质量问题和食品安全风险",
  lang18: "通过品控服务，可以为企业建立良好的品牌形象和声誉",
  lang19: "提升消费者对产品的信任度和忠诚度",
  lang20: "品控服务可以提高水产品的市场竞争力",
  lang21: "满足消费者对高品质产品的需求，增加产品的销售和市场份额",
  lang22: "品控服务可以提供数据分析和改进建议，帮助企业了解产品质量",
  lang23: "状况和市场需求，优化产品质量和生产流程，实现持续改进",
  lang24: "更换头像",
  lang25: "编号",
  lang26: "我的名字",
  lang27: "支付密码",
  lang28: "修改",
  lang29: "设置",
  lang30: "已填写",
  lang31: "主体名称",
  lang32: "添加新主体",
  lang33: "公司邮箱",
  lang34: "业务运营邮箱",
  lang35: "客服邮箱",
  lang36: "公司简介",
  lang37:
    "公司主要从事远洋捕捞生产和经营, 主要产品有金枪鱼及兼捕鱼种等海产品及加工制品。公司现有低温金枪鱼钓、超低温金枪鱼钓、水产品贸易三大业务板块。拥有70多艘金枪鱼钓作业渔船，是国内规模最大、作业范围最广、产品产量最高、金枪鱼种类最全的金枪鱼延绳钓专业公司；在金枪鱼钓渔船装备、生产能力、管理技术、人才储备等方面均处于国内领先水平。公司在境内外设有10多个分支机构。",
  lang38: "申请流程",
  lang39: "注册平台账号",
  lang40: "完成企业认证",
  lang41: "审核资料通过",
  lang42: "申请入驻会员企业",
  lang43: "资料复核",
  lang44: "成为会员企业",
  lang45: "立即申请成为会员企业",
  lang46: "金融服务",
  lang47: "港口清关",
  lang48: "服务介绍",
  lang49:
    "全球交割仓包括交易平台自有的交割仓和与国内外合作伙伴共建的交割仓，涵盖了金枪鱼主要产区和消费区的重要城市和港口。",
  lang50: "服务流程",
  lang51:
    "公司主要从事远洋捕捞生产和经营, 主要产品有金枪鱼及兼捕鱼种等海产品及加工制品。公司现有低温金枪鱼钓、超低温金枪鱼钓、水产品贸易三大业务板块。拥有70多艘金枪鱼钓作业渔船，是国内规模最大、作业范围最广、产品产量最高、金枪鱼种类最全的金枪鱼延绳钓专业公司；在金枪鱼钓渔船装备、生产能力、管理技术、人才储备等方面均处于国内领先水平。 公司主要从事远洋捕捞生产和经营, 主要产品有金枪鱼及兼捕鱼种等海产品及加工制品。",
  lang52:
    "公司现有低温金枪鱼钓、超低温金枪鱼钓、水产品贸易三大业务板块。拥有70多艘金枪鱼钓作业渔船，是国内规模最大、作业范围最广、产品产量最高、金枪鱼种类最全的金枪鱼延绳钓专业公司；在金枪鱼钓渔船装备、生产能力、管理技术、人才储备等方面均处于国内领先水平。 公司主要从事远洋捕捞生产和经营, 主要产品有金枪鱼及兼捕鱼种等海产品及加工制品。公司现有低温金枪鱼钓、超低温金枪鱼钓、水产品贸易三大业务板块。",
  lang53: "关注新动态",
  lang54: "明确新方向",
  lang55: "来源",
  lang56: "点赞",
  lang57: "已点赞",
  lang58: "共建新生态",
  lang59: "合作达共赢",
  lang60: "点赞成功",
  lang61: "我的交易（买）",
  lang62: "我的交易（卖）",
  lang63: "订单详情",
  lang64: "此订单",
  lang65: "订单创建时间",
  lang66: "首款服务费",
  lang67: "首款",
  lang68: "首款应付合计",
  lang69: "首款应收合计",
  lang70: "尾款会随着实际结算情况而变动，尾款以实际情况为准（多退少补）。",
  lang71: "尾款日",
  lang72: "尾款服务费",
  lang73: "尾款",
  lang74: "尾款应付合计",
  lang75: "尾款应收合计",
  lang76: "尾款应退合计",
  lang77: "尾款应退合计",
  lang78: "实际交割重量",
  lang79: "总交易额",
  lang80: "总",
  lang81: "买方客户",
  lang82: "我方",
  lang83: "买家银行卡",
  lang84: "卖方客户",
  lang85: "卖家银行卡",
  lang86: "操作人",
  lang87: "发货附件",
  lang88: "收货附件",
  lang89: "品控",
  lang90: "开发票",
  lang91: "查看发票",
  lang92: "查看交易详单",
  lang93: "下载服务费回执",
  lang94: "线上合同签署短信已发送...",
  lang95: "接收手机号",
  lang96: "请留意手机短信，并及时签署。",
  lang97: "我知道了",
  lang98: "尾款延期",
  lang99: "延期至",
  lang100: "发起补充协议",
  lang101: "签署补充协议",
  lang102:
    "本合同之修订条款经各方当事人充分协商并达成一致意见后，须由原合同涉及的所有三方当事人签字确认，始得生效。",
  lang103: "目前仅【集装箱号】支持修改",
  lang104: "原集装箱号",
  lang105: "新集装箱号",
  lang106: "请输入新的集装箱号",
  lang107: "我已知晓并同意以上内容",
  lang108: "填写到货港",
  lang109: "请与买方协商一致后填写",
  lang110: "到货港",
  lang111: "出发港不能为空",
  lang112: "操作日志",
  lang113: "主体名称",
  lang114: "操作内容",
  lang115: "操作时间",
  lang116: "请选择日期",
  lang117: "延期成功",
  lang118: "此操作将【支付仓单】, 是否继续?",
  lang119: "提示",
  lang120: "取消订单即为违约，将扣除冻结保证金。",
  lang121: "是否确认取消订单？",
  lang122: "取消成功",
  lang123: "文件下载失败",
  lang124: "出售货源",
  lang125: "切换主体",
  lang126: "账号关联",
  lang127: "主账号信息",
  lang128: "当前登录账号",
  lang129: "法人",
  lang130: "主体账号",
  lang131: "子账号列表",
  lang132: "添加账号",
  lang133: "暂无子账号信息，",
  lang134: "去添加",
  lang135: "子账号角色",
  lang136: "账号负责人",
  lang137: "绑定手机号",
  lang138: "操作",
  lang139: "编辑修改",
  lang140: "解绑账号",
  lang141: "当前子账号信息",
  lang142: "编辑子账号",
  lang143: "新增子账号",
  lang144: "财务",
  lang145: "交易员",
  lang146: "请选择子账号角色",
  lang147: "账号负责人信息",
  lang148:
    "需保证照片内容真实有效，不得作任何修改，仅支持.jpg、.jpeg、.png、.gif图片格式，图片大小不能超过10M",
  lang149: "请完善以下信息",
  lang150: "负责人手机号",
  lang151: "非当前登录账号",
  lang152: "再次输入以确认填写内容",
  lang153: "当前账号手机号",
  lang154: "**秒后重新获取",
  lang155: "已阅读并同意",
  lang156: "《子账户添加协议》",
  lang157: "提交子账户信息",
  lang158: "请阅读并同意《子账户添加协议》",
  lang159: "请输入负责人手机号",
  lang160: "请再次输入负责人手机号",
  lang161: "此操作将解除绑定, 是否继续?",
  lang162: "解绑成功",
  lang163: "上传图片大小不能超过 10MB!",
  lang164: "人点赞",
  lang165: "关注的交易",
  lang166: "报关单列表",
  lang167: "报关单号",
  lang168: "生产船",
  lang169: "商品名称",
  lang170: "可申报数量",
  lang171: "若您的货源属于深圳本地自捕鱼回货，请联系专属客服上传报关单",
  lang172: "个人账户",
  lang173: "仓单管理",
  lang174: "仓单录入",
  lang175: "审核记录",
  lang176: "原始仓单",
  lang177: "注册仓单",
  lang178: "发票助手",
  lang179: "报关单",
  lang180: "规则",
  lang181: "请选择",
  lang182: "开票记录",
  lang183: "订单品项规格",
  lang184: "下单时间",
  lang185: "开票金额以实际发票为准",
  lang186: "此功能仅适用于交易中产生的平台服务费；",
  lang187: "服务费不能合并开票，发票和订单会一一对应。",
  lang188: "下一步",
  lang189: "已选",
  lang190: "个订单，将开具",
  lang191: "张发票",
  lang192: "可开票订单",
  lang193: "不可开票订单",
  lang194: "请至少选择一条订单",
  lang195: "服务费发票",
  lang196: "发票类型",
  lang197: "开票记录",
  lang198: "包含订单个数",
  lang199: "开票申请时间",
  lang200: "金额",
  lang201: "转入入驻保证金",
  lang202: "转入银行卡",
  lang203: "待转入列表",
  lang204: "刷新",
  lang205: "序号",
  lang206: "发起时间",
  lang207: "取消转入",
  lang208: "请确认保证金转账信息",
  lang209: "支付金额",
  lang210: "收款方名称",
  lang211: "收款方账户",
  lang212: "收款方银行",
  lang213: "银行行联号",
  lang214: "附言",
  lang215: "转入金额必须为数字且必须大于0",
  lang216: "请选择银行卡",
  lang217: "此操作将【取消转入】, 是否继续?",
  lang218: "转出入驻保证金",
  lang219: "转出金额必须为数字且必须大于0",
  lang220: "交收记录",
  lang221: "交收记录详情",
  lang222: "仓单号",
  lang223: "仓库名称",
  lang224: "原始仓库凭证号",
  lang225: "规格名称",
  lang226: "商品数量",
  lang227: "卖方公司",
  lang228: "过户时间",
  lang229: "合同编号",
  lang230: "请输入关键字进行搜索",
  lang231: "搜索",
  lang232: "审核通过",
  lang233: "原始仓单号",
  lang234: "申请时间",
  lang235: "审核被驳回",
  lang236: "驳回原因",
  lang237: "去修改",
  lang238: "请选择仓库名称",
  lang239: "附件图片",
  lang240: "请点击上传",
  lang241: "原始凭证号",
  lang242: "请选择品类",
  lang243: "产地",
  lang244: "请选择产地",
  lang245: "冷冻方式",
  lang246: "请选择冷冻方式",
  lang247: "卸货港口",
  lang248: "请选择卸货港口",
  lang249: "仓单图片",
  lang250: "捕捞方式",
  lang251: "请选择捕捞方式",
  lang252: "报关地",
  lang253: "请选择报关地",
  lang254: "生产船号",
  lang255: "报关单号",
  lang256: "进关时间",
  lang257: "生产船号企业",
  lang258: "提单号",
  lang259: "规格",
  lang260: "数量（吨）",
  lang261: "请选择规格",
  lang262: "请点击输入（只能输入数字，最多4位小数）",
  lang263: "新增",
  lang264: "合计",
  lang265: "提交仓单",
  lang266: "请填写原始凭证号",
  lang267: "请输入正确的数字（必须为数字，最多四位小数）",
  lang268: "最多上传9张图片",
  lang269: "只允许上传一张照片。如需修改，请删除后重新上传",
  lang270: "请完善规格、数量（吨）信息",
  lang271: "提交成功，请等待审核",
  lang272: "仓单详情",
  lang273: "最后变更时间",
  lang274: "生产船所属企业",
  lang275: "注销仓单",
  lang276: "注销仓单后，仓单将返回“原始仓单”",
  lang277: '注册仓单可以用于"关联仓单"交易',
  lang278: "查看交收记录",
  lang279: "换绑银行卡",
  lang280: "下拉列表只展示最新的100条数据，如需更多，请输入精确信息",
  lang281: "银行卡开户手机号",
  lang282: "必须是【银行卡开户人手机号】",
  lang283: "《开户协议》变更中..",
  lang284: "请留意手机短信，并前往签署协议，签署完成后，即可变更银行卡成功。",
  lang285: "请提醒法人留意手机短信",
  lang286: "并前往签署协议。",
  lang287: "请输入银行卡开户手机号",
  lang288: "变更银行卡",
  lang289: "请核对提现信息",
  lang290: "请输入支付密码",
  lang291: "请输入8-10位字母数字组合，不区分大小写",
  lang292: "还没有支付密码？去",
  lang293: "设置支付密码",
  lang294: "提现金额必须为数字且必须大于0",
  lang295: "提现成功",
  lang296: "转出异常，请联系管理员",
  lang297: "支付密码错误，请重新输入",
  lang298: "交易排行榜公示",
  lang299: "时间范围",
  lang300: "全国榜",
  lang301: "排名",
  lang302: "名称",
  lang303: "交易额(元)",
  lang304: "暂无排行～",
  lang305: "深圳榜",
  lang306: "《开户协议》",
  lang307: "《违规违约协议》",
  lang308: "《信息服务协议》",
  lang309: "《交易商服务协议》",
  lang310: "《采购服务协议》",
  lang311: "《账号关联协议书》",
  lang312: "《交易平台资金结算服务三方协议》",
  lang313: "《全球高端水产品交易平台个人端用户交易规则》",
  lang314: "规则目录",
  lang315: "平台规则详情",
  lang316: "认证开户",
  lang317: "开户成功后即可参与平台交易",
  lang318: "协议签署中，开户成功后即可参与平台交易",
  lang319: "重新发起协议",
  lang320: "重新开户",
  lang321: "认证开户失败，请",
  lang322: "合同签署失败",
  lang323: "重新发起协议",
  lang324: "企业信息登记中",
  lang325: "登记成功 ,请",
  lang326: "前往开户",
  lang327: "编辑个人资料",
  lang328: "点击发布竞价",
  lang329: "点击发布挂牌",
  lang330: "暂未开户",
  lang331: "查看详情",
  lang332: "数据统计",
  lang333: "浏览客户数（人）",
  lang334: "交易客户数（人）",
  lang335: "销售金额（元）",
  lang336: "采购金额（元）",
  lang337: "当前帐号未开户，无法查看",
  lang338: "《开户协议》生成中..",
  lang339: "请提醒法人留意手机短信，并前往签署协议。签署完成后，即可开户成功。",
  lang340: "当前帐号未开户，无发布权限",
  lang341: "开户协议签署中，无发布权限",
  lang342: "该帐号暂不支持发布货源",
  lang343: "开市中",
  lang344: "休市中",
  lang345: "周一至周五（节假日除外）",
  lang346: "上午：09:00-11:30",
  lang347: "下午：13:00-16:30",
  lang348: "品类专区",
  lang349: "请输入关键词",
  lang350: "最近搜索",
  lang351: "竞价",
  lang352: "挂牌",
  lang353: "最高价",
  lang354: "一键复制",
  lang355: "已下架",
  lang356: "仅看成交",
  lang357: "查看结算单",
  lang358: "预估总吨数（吨）",
  lang359: "预估均价（元/吨）",
  lang360: "实际总吨数（吨）",
  lang361: "调整后均价（元/吨）",
  lang362: "结算单",
  lang363: "查看",
  lang364: "下载",
  lang365: "总货款",
  lang366: "买方已付",
  lang367: "尾款",
  lang368: "服务费",
  lang369: "合计应付",
  lang370: "应退金额",
  lang371: "买方应付",
  lang372: "发起尾款",
  lang373: "点击上传",
  lang374: "请输入实际吨数",
  lang375: "请输入数字，最多包含四位小数",
  lang376: "请输入实际均价",
  lang377: "上传附件大小不能超过 200MB!",
  lang378: "最多上传1个附件",
  lang379: "请上传结算单",
  lang380: "发起成功",
  lang381: "最终确认",
  lang382: "初始预估",
  lang383: "暂无数据",
  lang384: "品名",
  lang385: "箱数",
  lang386: "箱数不能为空",
  lang387: "请输入整数",
  lang388: "请点击输入",
  lang389: "箱重",
  lang390: "箱重不能为空",
  lang391: "总净重",
  lang392: "成交价格",
  lang393: "退货率",
  lang394: "请输入数字，最多包含两位小数",
  lang395: "单价",
  lang396: "总金额",
  lang397: "请完善表格信息",
  lang398: "当前最高价",
  lang399: "条数",
  lang400: "单价不能为空",
  lang401: "点击编辑",
  lang402: "总计",
  lang403: "您的出价",
  lang405: "本次加价幅度",
  lang406: "返回修改",
  lang407: "当前出价小于当前最高价，不可出价",
  lang408: "倒计时",
  lang409: "天",
  lang410: "出价详情",
  lang411: "出价时间",
  lang412: "关闭",
  lang413: "当前所需保证金",
  lang414: "您的入驻保证金",
  lang415: "本次交易要求入驻保证金内金额不低于",
  lang416: "若您的保证金账户资金充足，则可直接报名成功；",
  lang417: "若您成功获拍后未履约，平台有权扣除您的入驻保证金。",
  lang418: "报名竞价",
  lang419: "入驻保证金不足,去转入",
  lang420: "报关单选择",
  lang421: "确认选择",
  lang422: "仓单编号",
  lang423: "位置信息获取中",
  lang424: "点击获取位置",
  lang425: "地图",
  lang426: "输入地址查找点位信息",
  lang427: "当前位置",
  lang428: "核对总重量",
  lang429: "箱",
  lang430: "交易箱数",
  lang431: "原交易重量",
  lang432: "请输入总交易重量",
  lang433: "数值浮动较大,请注意核对。",
  lang434: "日期",
  lang435: "折算人民币",
  lang436: "登录发现更多精彩！",
  lang437: "客服电话",
  lang438: "地图选点",
  lang439: "当前选择地址",
  lang440: "若您需要本服务，请留下您的联系方式",
  lang441: "服务申请",
  lang442: "电话咨询",
  lang443: "企业名称",
  lang444: "请输入企业名称",
  lang445: "申请",
  lang446: "电话",
  lang447: "申请成功",
  lang448: "收起",
  lang449: "默认",
  lang450: "距离优先",
  lang451: "筛选",
  lang452: "转入转出明细",
  lang453: "操作类型",
  lang454: "交易金额",
  lang455: "银行卡",
  lang456: "是否定金",
  lang457: "定金",
  lang458: "解冻状态",
  lang459: "转入明细",
  lang460: "转出",
  lang461: "状态",
  lang462: "转出异常,请再次申请",
  lang463: "转出中",
  lang464: "已转出",
  lang465:
    "为保障买方客户权益，若当前账号主体下有未完成的交易或者完成交易不足7*24小时，入驻保证金须不低于10万元整。",
  lang466: "营业执照信息",
  lang467: "法人信息",
  lang468: "经办人信息",
  lang469: "银行卡信息",
  lang470: "营业执照有效期",
  lang471: "请输入营业执照有效期",
  lang472: "资产总额",
  lang473: "请输入资产总额(元)",
  lang474: "近一年营业收入(元)",
  lang475: "请输入近一年营业收入(元)",
  lang476: "从业人员",
  lang477: "请输入从业人员信息",
  lang478: "法人姓名",
  lang479: "请输入法人姓名",
  lang480: "法人身份证号",
  lang481: "请输入法人身份证号",
  lang482: "法人身份证有效期",
  lang483: "请输入法人身份证有效期",
  lang484: "法人手机号",
  lang485: "请输入法人手机号",
  lang486: "法人本人需签署《开户协议》，请确认手机号正确无误。",
  lang487: "请上传经办人照片",
  lang488: "经办人姓名",
  lang489: "请输入经办人姓名",
  lang490: "经办人身份证号",
  lang491: "请输入经办人身份证号",
  lang492: "经办人身份证有效期",
  lang493: "请输入经办人身份证有效期",
  lang494: "请输入银行卡号",
  lang495: "请输入开户行检索，并从下拉框内选择",
  lang496: "登记",
  lang497: "签署完成后，即可开户成功。",
  lang498: "统一社会信用代码不能为空",
  lang499: "统一社会信用代码输入错误，请仔细检查",
  lang500: "请输入数字",
  lang501: "请上传法人身份证照片人像面",
  lang502: "请上传法人身份证照片国徽面",
  lang503: "请上传经办人身份证照片人像面",
  lang504: "请上传经办人身份证照片国徽面",
  lang505: "开票信息",
  lang506: "开票中",
  lang507: "服务费发票",
  lang508: "发票信息（发票信息为开户信息，不可更改）",
  lang509: "抬头类型",
  lang510: "企业单位",
  lang511: "个人/非企业单位",
  lang512: "公司税号",
  lang513: "发票金额",
  lang514: "预计开具发票**张",
  lang515: "订单详细信息",
  lang516: "品项规格",
  lang517: "订单编号",
  lang518: "包含1个订单，将开具1张发票",
  lang519: "1张发票，含1个订单",
  lang520: "接收方式",
  lang521: "电子邮件",
  lang522: "请输入电子邮件",
  lang523: "重新发送",
  lang524: "性别",
  lang525: "添加新的银行卡",
  lang526: "注销",
  lang527: "查看平台账户",
  lang528: "平台账户信息",
  lang529: "请输入",
  lang530: "银行类型",
  lang531: "添加",
  lang532: "是否注销该银行卡？",
  lang533: "注销成功",
  lang534: "内容已复制",
  lang535: "添加成功！",
  lang536: "放货详情",
  lang537: "上传附件",
  lang538: "预计成交吨数",
  lang539: "实际出库吨数",
  lang540: "请输入吨数",
  lang541:
    "若实际出库吨数与预计成交吨数不等，涉及金额调整，须签署补充协议后，多退少补",
  lang542: "请上传附件",
  lang543: "（支持上传图片，pdf,excel,word文件，最多可上传9个文件）",
  lang544: "将文件拖到此处，或点击上传",
  lang545: "请输入实际出库吨数",
  lang546: "实际出库吨数应为数字，最多包含4位小数",
  lang547: "放货成功",
  lang548: "收货成功",
  lang549: "请使用绑定银行卡向以下账户转账",
  lang550: "收款方银行行联号",
  lang551: "请把附言复制后，填写在【用途】一栏",
  lang552: "实际吨数",
  lang553: "预估吨数",
  lang554: "应补货款",
  lang555: "实付合计",
  lang556: "请选择银行账户进行支付",
  lang557: "请勿使用其他银行账户进行支付，否则会",
  lang558: "支付失败",
  lang559: "若银行账户单笔限额小于实付合计，请点击选择",
  lang560: "拆单支付",
  lang561: "跳转支付",
  lang562: "查询支付状态",
  lang563: "取消拆单",
  lang564: "拆单",
  lang565: "拆单数量最小为2，最大为50",
  lang566: "支付任意拆单后，不可重置拆单",
  lang567: "请仔细确认此次拆单，确认无误后，请点击",
  lang568: "确认拆单",
  lang569: "点击后拆单不可取消或重置",
  lang570: "拆单编号",
  lang571: "去支付",
  lang572: "已支付",
  lang573: "支付完成",
  lang574: "未查到开户信息,需要去【我的账户】中进行开户",
  lang575: "请输入拆单数量,拆单数量最小为2，最大为50",
  lang576: "请先选择支付银行卡",
  lang577: "货款未转入",
  lang578: "请确认转账信息",
  lang579: "货款已转入",
  lang580: "修改支付密码",
  lang581: "获取验证码的手机号",
  lang582: "请再次8-10位字母数字组合，不区分大小写",
  lang583: "两次输入的密码不一致",
  lang584: "我已认证阅读并完全理解以上内容",
  lang585: "同意并继续",
  lang586: "报名竞价需要由法人或者财务支付对应的履约保证金；",
  lang587: "若未获拍，履约保证金会自动退还至原打款账户",
  lang588: "若成功获拍，履约保证金会在您支付全部货款后自动退还至原打款账户",
  lang589: "若成功拍下后未履约，履约保证金会将被扣除",
  lang590: "支付完成后，请点击",
  lang591: "支付完毕，查询报名状态",
  lang592: "确认报名是否成功。",
  lang593: "本次履约保证金支付通道如下",
  lang594: "支付链接",
  lang595: "注意：转账时请把附言复制填写到用途中",
  lang596: "复制成功",
  lang597: "最高",
  lang598: "发布时间",
  lang599: "成交日期",
  lang600: "结束日期",
  lang601: "添加关注成功",
  lang602: "取消关注成功",
  info1: "多规格",
  info2: "加载中",
  info3: "围网预售",
  info4: "首尾款比例",
  info5: "首尾款不含服务费，以实际结算为准",
  info6: "首款金额",
  info7: "尾款金额",
  info8: "总货值高于最新出价即可",
  info9: "竞价天数",
  info10: "延时次数",
  info11: "围观次数",
  info12: "次",
  info13: "成交后顺延**个小时交货",
  info14: "常见问题",
  info15: "交收起止日期",
  info16: "取消关注",
  info17: "结算方式",
  info18: "首尾款不含服务费；首尾款会随着竞价过程变动；首尾款以实际结算为准。",
  info19: "当前价",
  info20: "共**条",
  info21: "出价",
  info22: "领先",
  info23: "淘汰",
  info24: "货源形式",
  info25: "品牌",
  info26: "厂号",
  info27: "生产日期",
  info28: "附件资料",
  info29: "海运温度",
  info30: "集装箱号",
  info31: "备注条款",
  info32: "发货地",
  info33: "单次结算",
  info34: "首尾款模式",
  info35: "鱼货信息",
  info36: "定重",
  info37: "过磅",
  info38: "交收形式",
  info39: "件数",
  info40: "件重",
  info41: "鱼种、规格、单价如下",
  info42:
    "注:经双方协商，此批货物预售价格一**元/吨，实际成交价格按当时市场价格进行结算",
  info43: "鱼体",
  info44: "标签",
  info45: "鱼鳃",
  info46: "冰量",
  info47: "产品溯源文件",
  info48: "总重量",
  info49: "购买箱数",
  info50: "以下仅为预估，实际以卖家核算重量为准进行进算",
  info51: "首款比例",
  info52: "尾款比例",
  info53: "预计尾款",
  info54: "预计服务费",
  info55: "应付合计",
  info56: "预计应付合计",
  info57: "购买企业",
  info58: "确认购买",
  info59:
    "尊敬的用户，您的今日交易笔数/金额已达到当前级别的上限。为了您的账户安全及交易体验，请留意我们的交易规则，或联系客服了解如何提升您的用户等级。",
  info60: "点击阅读",
  info61: "请选择支付账户",
  info62: "请按要求填写购买箱数",
  info63: "购买成功",
  info64: "购买箱数不能为空",
  info65: "购买箱数不能低于起售箱数",
  info66: "当前企业",
  info67: "设置收款银行卡",
  info68: "请选择您想交易的货源形式",
  info69: "仓单交易",
  info70: "现货交易",
  info71: "自捕鱼竞价",
  info72: "三文鱼交易",
  info73: "请问是否需要平台人工介入，参与交割流程？",
  info74: "自主交收，不需要平台品控介入",
  info75: "平台交收，交割时会有品控人员到达现场",
  info76: "请选择当前企业",
  info77: "请设置收款银行卡",
  info78: "请选择平台人工介入，参与交割流程",
  info79: "第 1 步 关联仓单",
  info80: "第 2 步 竞价设置",
  info81: "第 2 步 交易信息",
  info82: "若涉及自捕回货货源，请选择对应的报关单单号",
  info83: "找不到需要的报关单？点击",
  info84: "联系客服",
  info85: "点击选择报关单",
  info86: "更改绑定",
  info87: "关联仓单",
  info88: "请选择关联仓单",
  info89: "商品信息",
  info90: "选填参数",
  info91: "选择日期",
  info92: "返回",
  info93: "存草稿",
  info94: "数量",
  info95: "总价",
  info96: "起拍价(元/吨)",
  info97: "加价幅度(元/吨)",
  info98: "请确认填入信息",
  info99: "交易信息",
  info100: "重新编辑",
  info101: "取消提交",
  info102: "确认提交",
  info103: "五分钟后提交",
  info104: "此交易将在**后提交",
  info105: "草稿箱",
  info106: "标题",
  info107: "此操作将删除该条草稿，是否继续？",
  info108: "代入此草稿",
  info109: "请选择仓单",
  info110: "请输入卸货港口",
  info111: "请选择商品信息",
  info112: "请输入价格信息",
  info113: "请选择单位",
  info114: "请输入重量",
  info115: "请输入总价",
  info116: "请输入竞价日期",
  info117: "请输入竞价时间",
  info118: "请输入竞价时长",
  info119: "请输入起拍价",
  info120: "请输入加价幅度(元/吨)",
  info121: "单价为空,无法计算",
  info122: "已存为草稿，请点击【草稿箱】查看",
  info123: "请上传货源照片",
  info124: "您设置的价格过低，请确认无误。",
  info125: "确认无误",
  info126: "返回编辑",
  info127: "取消提交成功",
  info128: "第 1 步 订单信息",
  info129: "第 1 步 货源信息",
  info130: "第 2 步 竞价设置",
  info131: "第 2 步 挂牌设置",
  info132: "第 3 步 交割设置",
  info133: "请输入标题",
  info134: "品名不能为空",
  info135: "规格不能为空",
  info136: "总净重不能为空",
  info137: "数量(箱)",
  info138: "请选择品牌",
  info139: "请选择厂号",
  info140: "规格及大小",
  info141: "收货地址",
  info142: "请输入国家、地区或发货港",
  info143: "请选择海运温度",
  info144: "自定义海运温度(℃)",
  info145: "至",
  info146: "开始月份",
  info147: "结束月份",
  info148: "渔船船名",
  info149: "请输入渔船船名",
  info150: "运输船船名",
  info151: "请输入运输船船名",
  info152: "（上传照片，最多可上传30张）",
  info153: "（上传照片,每个上传一张）",
  info154: "证件",
  info155: "只能上传pdf,excel,word文件，且不超过20M",
  info156: "选择定价方式",
  info157: "固定价格",
  info158: "阶梯定价",
  info159: "起售箱数",
  info160: "请输入起售箱数",
  info161: "请输入箱数",
  info162: "箱数区间(箱)",
  info163: "价格(元/kg)",
  info164: "请输入价格",
  info165: "卖家只能在竞价开始前报名，请预留足够时间。",
  info166: "起拍价(元)",
  info167: "增加区间",
  info168: "任意时间点",
  info169: "竞价类型",
  info170: "短时竞价",
  info171: "长期竞价",
  info172: "竞价天数",
  info173: "请输入竞价天数",
  info174: "请选择竞价时长",
  info175: "预计**结束；",
  info176: "若竞价结束前2小时有人出价则竞价自动延期24小时；",
  info177: "竞价天数不包含休市时间。",
  info178: "交割方式",
  info179: "现货交割",
  info180: "远期交割",
  info181: "发货期限",
  info182: "备货期限",
  info183: "货款总价值",
  info184: "首尾款比例之和为100%",
  info185: "尾款最晚日期",
  info186: "不确定",
  info187: "选择尾款日",
  info188: "尾款支付日期",
  info189: "确定尾款支付时间",
  info190: "小时不能为空",
  info191: "请选择货源名称",
  info192: "请输入数量（箱）",
  info193: "请输入规格及大小",
  info194: "请输入产地名称",
  info195: "请选择捕捞时间",
  info196: "请输入渔船名称",
  info197: "请输入运输船名称",
  info198: "请输入自定义海运温度",
  info199: "请选择货源地址",
  info200: "请输入地址",
  info201: "请输入件数",
  info202: "请输入件重",
  info203: "请选择生产日期",
  info204: "请选择竞价日期",
  info205: "请选择竞价时间",
  info206: "请选择竞价开始时间",
  info207: "请选择竞价结束时间",
  info208: "请输入降价幅度(元/吨)",
  info209: "请选择备货期限",
  info210: "请选择结算方式",
  info211: "请选择运费",
  info212: "冻结履约保证金必填",
  info213: "请选择竞价类型",
  info214: "请输入首款比例",
  info215: "请输入尾款比例",
  info216: "请选择尾款支付日期",
  info217: "请选择定价方式",
  info218: "请选择交割方式",
  info219: "请选择发货期限",
  info220: "请选择尾款最晚日期",
  info221: "以上",
  info222: "小时不能为空",
  info223: "备货期限不能低于1小时",
  info224: "备货期限不能超过48小时",
  info225: "此操作将删除该条草稿， 是否继续?",
  info226: "请上传图片",
  info227: "上传附件大小不能超过 20MB!",
  info228: "最多上传30个附件",
  info229: "请上传标签图片",
  info230: "请上传品牌图片",
  info231: "请上传鱼体图片",
  info232: "请上传鱼鳃图片",
  info233: "请上传冰量图片",
  info234: "请上传证件图片",
  info235: "输入的最大价格不能低于最小价格，请仔细检查所填数据",
  info236: "自定义",
  info237: "保证金不足，请转入",
  info238: "已超过最大行数",
  info239: "最多支持5级阶梯定价",
  info240: "请先输入起售箱数",
  info241: "价格不能为空",
  info242: "请输入数字，最多保留两位小数",
  info243: "价格不能低于50元/kg",
  info244: "价格不能高于150元/kg",
  info245: "最大箱数不能为空",
  info246:
    "若实际出库重量与预计重量有出入，以实际出库重量为准，产生的差额多退少补；",
  info247:
    "为保证后续交易流程通畅，预计重量将乘以90%后显示，买方会在交割环节补齐全部货款，请您不要担心。",
  info248: "首款**元",
  info249: "尾款预计**元",
  info250: "尾款日期",
  info251:
    "您可在尾款最晚日到来之前，找到订单， 点击【发起尾款】，开启尾款流程。",
  info252: "企业主体",
  info253: "收款银行卡",
  info254: "渔船名称",
  info255: "运输船船名",
  info256: "产品溯源证件",
  info257: "其他照片",
  info258: "交易设置",
  info259: "定价方式",
  info260: "箱数区间（小）",
  info261: "箱数区间（大）",
  info262: "最晚**前发货",
  info263: "成交后**个小时内交货",
  info264: "单价（元/kg）",
  info265: "总金额（元）",
  info266: "查看各个规格净重",
  info267: "代理货源",
  info268: "海外专区",
  info269: "请输入关键词进行搜索，包括品名、产地等",
  info270: "发布货源",
  info271: "地区",
  info272: "全部分类",
  info273: "目的港",
  info274: "出发港",
  info275: "储藏温度",
  info276: "咨询",
  info277: "货源详情",
  info278: "规格",
  info279: "包装",
  info280: "包装规格",
  info281: "总毛重",
  info282: "若您想要购买此货源，请联系平台工作人员",
  info283: "海外用户登录入口",
  info284: "中国大陆地区用户登录入口",
  info285: "登录手机号",
  info286: "请输入内容",
  info287: "更换手机号",
  info288: "绑定手机号",
  info289: "登录邮箱",
  info290: "换绑邮箱",
  info291: "绑定邮箱",
  info292: "请输入想要更换的新手机号",
  info293: "更换邮箱",
  info294: "当前邮箱",
  info295: "请输入邮箱地址",
  info296: "请输入手机号码",
  info297: "认证审核中，认证通过之前，您还可以修改补充。",
  info298: "认证成功，您可以发布货源了。",
  info299: "认证失败，请编辑修改后重新提交。",
  info300: "认证信息",
  info301: "一： 基本信息",
  info302: "公司类型",
  info303: "成立日期",
  info304: "点击选择日期",
  info305: "注册日期",
  info306: "执照有效期",
  info307: "注册资本",
  info308: "税号",
  info309: "在华注册号",
  info310: "营业执照文件",
  info311: "二：经营信息",
  info312: "欧盟注册号",
  info313: "其他证书",
  info314: "银行名称",
  info315: "银行地址",
  info316: "收款人",
  info317: "收款人地址",
  info318: "四：联系方式",
  info319: "微信号",
  info320: "五：公司介绍",
  info321: "产品简介",
  info322: "官网地址",
  info323: "其他资料",
  info324: "审核结果接受邮箱",
  info325: "认证信息提交成功",
  info326: "请等待审核",
  info327: "若希望修改认证信息，请联系平台工作人员",
  info328: "最多上传30张图片",
  info329: "已对接",
  info330: "提交时间",
  info331: "当前展示中",
  info332: "复制信息，再次上架",
  info333: "编辑后重新上架",
  info334: "操作成功",
  info335: "请填写货源信息",
  info336: "无包装",
  info337: "产品照片",
  info338: "（至少5张，至多50张）",
  info339: "报价模式",
  info340: "报价信息",
  info341: "报价",
  info342: "输入目的港",
  info343: "输入出发港",
  info344: "请输入报价",
  info345: "发布",
  info346: "货源信息提交成功",
  info350: "总净重与总毛重误差上下不超过10%",
  info351: "请上传至少5张货源图片",
  info352: "账号管理",
  info353: "我的货源",
  info354: "《三文鱼专区交易须知（试运营）》",
  info355: "请在摘牌后30分钟内签署合同，否则该次摘牌无效，交易失败。",
  info356: "手机号登录",
  info367: "邮箱登录",
  info368: "待发布",
  info369: "上传",
  info370: "当前总价",
  info371: "成交总价",
  info372: "起拍总价",
  info373: "请核对订单",
  info374: "邮箱格式不正确",
  info375: "当前账号未认证成功，请先去认证～",
  info376: "触发延时",
  info377: "摘牌记录",
  info378: "摘牌方",
  info379: "未发布",
  info380: "首尾款不含服务费；",
  info381: "首尾款会随着竞价过程变动；",
  info382: "首尾款以实际结算为准。",
  info383: "开售时公布",
  info384: "开售时间",
  info385: "距开售",
  info386: "报名人数",
  info387: "上传打款凭证成功",
  info388: "上传打款凭证",
  info389: "将文件拖到此处，或点击上传",
  info390: "打款凭证",
  info391: "规格如下",
  info392: "三：银行账户",
  info393: "姓名",
  info394: "已成交",
  info395: "交易须知",
  info396: "公司类型",
  info397: "当前账号没有发布货源的权限",
  info398: "出价记录共**条",
  info399: "成品专区",
  info400: "件",
  info401: "美元",
  info402: "公斤",
  info403: "生产",
  info404: "规格（单个产品）",
  info405: "总 毛 重（kg）",
  info406: "总 净 重（kg）",
  info407: "储存温度",
  info408: "零下",
  info409: "原料产地",
  info410: "生产批次",
  info411: "保 质 期",
  info412: "产品种类",
  info413: "其他特性",
  info414: "英文名称",
  info415: "拉丁文名称",
  info416: "保护性冰衣所占比例",
  info417: "普通货源",
  info418: "成品货源",
  info419: "(单个产品)",
  info420: "每件净重",
  info421: "总毛重(kg)",
  info422: "计算所得",
  info423: "总净重(kg)",
  info424: "(建议上传5-10张)",
  info425: "(只能上传pdf,excel,word文件，且不超过20M)",
  info426: "单价(美元/kg)",
  info427: "总价(美元)",
  info428: "发布成功～",
  info429: "请输入保护性冰衣所占比例",
  info430: "保护性冰衣所占比例不能小于0",
  info431: "保护性冰衣所占比例不能大于10",
  info432: "中心价格",
  info433: "规格（中文）",
  info434: "规格（英文）",
  info435: "单价（USD/KG）",
  info436: "重量（KGS）",
  info437: "重量不能为空",
  info438: "规格详情",
};



// WEBPACK FOOTER //
// ./src/lang/zh.js